import React from 'react';
import clsx from 'clsx';

import { ListItemButton, type ListItemButtonProps, ListItemText, styled } from '@mui/material';
import { Icon } from 'app/main/components';
import FuseNavBadge from '../../FuseNavBadge';
import type { FuseNavProps } from '../../types/FuseNavProps';

interface RootProps extends ListItemButtonProps {
	itemPadding: number;
	target?: string;
	href?: string;
}

const Root = styled(ListItemButton, { shouldForwardProp: name => name !== 'itemPadding' })<RootProps>(
	({ theme, itemPadding }) => ({
		height: 40,
		width: '100%',
		borderRadius: '6px',
		margin: '0 0 4px 0',
		paddingRight: 12,
		paddingLeft: itemPadding > 80 ? 80 : itemPadding,
		'&.active': {
			backgroundColor: `${theme.palette.secondary.main}!important`,
			color: `${theme.palette.secondary.contrastText}!important`,
			pointerEvents: 'none',
			transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
			'& > .fuse-list-item-text-primary': {
				color: 'inherit'
			},
			'& > .fuse-list-item-icon': {
				color: 'inherit'
			}
		},
		'& > .fuse-list-item-icon': {
			marginRight: 12
		},
		'& > .fuse-list-item-text': {},
		color: theme.palette.text.primary,
		textDecoration: 'none!important'
	})
);

function FuseNavVerticalLink(props: FuseNavProps) {
	const { item, nestedLevel, onItemClick } = props;

	const itemPadding = nestedLevel > 0 ? 28 + nestedLevel * 16 : 12;

	return React.useMemo(
		() => (
			<Root
				component="a"
				href={item.url}
				target={item.target ? item.target : '_blank'}
				className="fuse-list-item"
				onClick={() => onItemClick && onItemClick(item)}
				role="button"
				itemPadding={itemPadding}
			>
				{item.icon && (
					<Icon
						icon={item.icon}
						className={clsx('fuse-list-item-icon mr-12 shrink-0 text-20', item.iconClass)}
						color="action"
					/>
				)}

				<ListItemText
					className="fuse-list-item-text"
					primary={item.title}
					classes={{ primary: 'text-13 fuse-list-item-text-primary' }}
				/>

				{item.badge && <FuseNavBadge badge={item.badge} />}
			</Root>
		),
		[item, itemPadding, onItemClick]
	);
}

const NavVerticalLink = FuseNavVerticalLink;

export default NavVerticalLink;
